import { ElevatorBusinessDirectionDisplay } from "./ElevatorBusinessDirectionDisplay";
import displayImg from "@/domains/estate/components/elevator/res/display-business@2x.png";

function getLabel(floor: number) {
  if (floor < 10) {
    return (
      <>
        <span className="text-[#272727]">0</span>
        {floor}
      </>
    );
  }
  return floor;
}

export function ElevatorBusinessFloorDisplay({
  value,
  direction,
}: {
  value: number;
  direction: "up" | "down" | "idle";
}) {
  return (
    <div className="relative flex justify-between items-center mx-auto mb-[30px] w-[192px] h-[84px] px-[25px]">
      <img src={displayImg} alt="" className="absolute inset-0" />

      <div className="relative z-1 top-4 text-[#3f3f3f]">
        <ElevatorBusinessDirectionDisplay direction="down" isActive={direction === "down"} />
      </div>

      <div className="relative z-1 flex justify-center items-center tabular-nums">
        <div className="text-[44px] text-center text-white">{getLabel(value)}</div>
      </div>

      <div className="relative z-1 top-4 text-[#3f3f3f]">
        <ElevatorBusinessDirectionDisplay direction="up" isActive={direction === "up"} />
      </div>
    </div>
  );
}
